<template>
  <div class="itemtype-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="itemtype"
            ref="intangibleCateValidate"
            :rules="intangibleCateValidate"
            action="javascript:void(0)">
        <FormItem label="分类名称"
                  prop="name">
          <Input v-model="itemtype.name"
                 placeholder="输入分类名称..."></Input>
        </FormItem>
        <FormItem label="分类图标"
                  prop="typeicon">
          <upload-thumb v-model="itemtype.typeicon"
                        ref="uploadthumb4"
                        :defaultList="thumblist4"
                        :autoCropWidth="70"
                        :autoCropHeight="70"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:70*70,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="点击取消分类的图标"
                  prop="typeicon1">
          <upload-thumb v-model="itemtype.typeicon1"
                        ref="uploadthumb5"
                        :defaultList="thumblist5"
                        :autoCropWidth="70"
                        :autoCropHeight="70"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:70*70,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <!-- <FormItem label="背景图"
                  prop="thumb">
          <upload-thumb v-model="itemtype.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="70"
                        :autoCropHeight="70"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:70*70,大小不超过2M</span>"></upload-thumb>
        </FormItem> -->
        <FormItem label="地图图标"
                  prop="icon">
          <upload-thumb v-model="itemtype.icon"
                        ref="uploadthumb2"
                        :defaultList="thumblist2"
                        :autoCropWidth="62"
                        :autoCropHeight="60"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:62*60,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="带文字地图图标"
                  prop="bigicon">
          <upload-thumb v-model="itemtype.bigicon"
                        ref="uploadthumb3"
                        :defaultList="thumblist3"
                        :autoCropWidth="62"
                        :autoCropHeight="234"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png,<br>建议图片尺寸:62*234,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="背景颜色"
                  prop="font_color">
          <Input v-model="itemtype.font_color"
                 placeholder="输入背景颜色..."></Input>
        </FormItem>
        <FormItem label="排序"
                  prop="sort">
          <Input v-model="itemtype.sort"
                 placeholder="数字越大越靠前..."></Input>
        </FormItem>
        <FormItem label="显示"
                  prop="status">
          <RadioGroup v-model="itemtype.status">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                :loading="tijiaoloading"
                @click="createintangibleCate('intangibleCateValidate')">提交</Button>
      </div>
    </Drawer>
    </Modal>
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";
import UploadThumb2 from "../common/thumb";
import UploadThumb3 from "../common/thumb";
import uploadthumb4 from "../common/thumb";
import uploadthumb5 from "../common/thumb";

export default {
  name: 'itemtype-list',
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传背景图"));
      } else {
        callback();
      }
    };
    const validateTypeIcon = (rule, value, callback) => {
      if (this.$refs["uploadthumb4"].uploadList.length == 0) {
        callback(new Error("请上传分类图标"));
      } else {
        callback();
      }
    };
    const validateTypeIcon1 = (rule, value, callback) => {
      if (this.$refs["uploadthumb5"].uploadList.length == 0) {
        callback(new Error("请上传点击取消的分类图标"));
      } else {
        callback();
      }
    };
    const validateicon = (rule, value, callback) => {
      if (this.$refs["uploadthumb2"].uploadList.length == 0) {
        callback(new Error("请上传地图图标"));
      } else {
        callback();
      }
    };
    const validatebigicon = (rule, value, callback) => {
      if (this.$refs["uploadthumb2"].uploadList.length == 0) {
        callback(new Error("请上传带文字地图图标"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      dataloading: true,
      tijiaoloading: false,
      thumblist: [],
      thumblist2: [],
      thumblist3: [],
      thumblist4: [],
      thumblist5: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: "分类图标",
          key: "typeicon",
          width: 100,
          render: (h, params) => {
            if (params.row.typeicon != null) {
              let thumbImg = this.$publicData.ossUrl + params.row.typeicon;
              return h("div", [
                h(
                  "Avatar",
                  {
                    props: {
                      src: thumbImg,
                      shape: "square",
                      size: "large",
                      click: ""
                    },
                  },
                  ""
                )
              ]);
            }

          }
        },
        // {
        //   title: '字体颜色',
        //   key: 'font_color',
        //   minWidth: 200
        // },
        {
          title: '显示',
          key: 'status',
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: '排序',
          key: 'sort',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  min: 0,
                  value: params.row.sort,
                  size: 'small',
                  number: true,
                  activeChange: false,
                },
                on: {
                  'on-change': (value) => {
                    this.changesort(params.row.id, value)
                  }
                }
              }, '排序')
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      itemtype: {
        name: '',
        thumb: '',
        font_color: '',
        sort: 0,
        status: 1,
      },
      showModalStatus: false,
      intangibleCateValidate: {
        name: [
          { required: true, message: '名称必须填写', trigger: 'blur' }
        ],
        // thumb: [
        //   { required: true, validator: validateThumb, trigger: "change" }
        // ],
        typeicon: [
          { required: true, validator: validateTypeIcon, trigger: "change" }
        ],
        typeicon1: [
          { required: true, validator: validateTypeIcon1, trigger: "change" }
        ],
        icon: [
          { required: true, validator: validateicon, trigger: "change" }
        ],
        bigicon: [
          { required: true, validator: validatebigicon, trigger: "change" }
        ],
        // font_color: [
        //   { required: true, message: '字体颜色必须填写', trigger: 'blur' }
        // ],
      },
    }
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    UploadThumb2,
    UploadThumb3,
    uploadthumb4,
    uploadthumb5
  },
  methods: {
    getTableList: function () {
      this.$api.itemtype.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel () {
      this.title = "添加分类";
      this.itemtype = {
        name: '',
        thumb: '',
        icon: '',
        bigicon: '',
        font_color: '',
        sort: 0,
        status: 1,
      };
      this.thumblist = new Array();
      this.thumblist2 = new Array();
      this.thumblist3 = new Array();
      this.thumblist4 = new Array();
      this.thumblist5 = new Array();
      this.$refs['intangibleCateValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑分类";
      this.itemtype = {
        name: '',
        thumb: '',
        icon: '',
        bigicon: '',
        font_color: '',
        sort: 0,
        status: 1,
      };
      this.thumblist = new Array();
      this.thumblist2 = new Array();
      this.thumblist3 = new Array();
      this.thumblist4 = new Array();
      this.thumblist5 = new Array();
      this.$refs['intangibleCateValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.itemtype.detail({ id: id }).then(res => {
        this.itemtype = res.result;
        if (this.itemtype.thumb != null && this.itemtype.thumb != '') {
          this.thumblist.push({
            name: this.itemtype.thumb,
            url: this.itemtype.thumb,
            status: 'finished',
          });
        }
        if (this.itemtype.icon != null && this.itemtype.icon != '') {
          this.thumblist2.push({
            name: this.itemtype.icon,
            url: this.itemtype.icon,
            status: 'finished',
          });
        }
        if (this.itemtype.bigicon != null && this.itemtype.bigicon != '') {
          this.thumblist3.push({
            name: this.itemtype.bigicon,
            url: this.itemtype.bigicon,
            status: 'finished',
          });
        }
        if (this.itemtype.typeicon != null && this.itemtype.typeicon != '') {
          this.thumblist4.push({
            name: this.itemtype.typeicon,
            url: this.itemtype.typeicon,
            status: 'finished',
          });
        }
        if (this.itemtype.typeicon1 != null && this.itemtype.typeicon1 != '') {
          this.thumblist5.push({
            name: this.itemtype.typeicon1,
            url: this.itemtype.typeicon1,
            status: 'finished',
          });
        }
      });
    },
    // 添加
    createintangibleCate (name) {
      this.tijiaoloading = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          // if (this.$refs['uploadthumb'].uploadList.length > 0) {
          //   this.itemtype.thumb = this.$refs['uploadthumb'].uploadList[0].url;
          // }
          if (this.$refs['uploadthumb2'].uploadList.length > 0) {
            this.itemtype.icon = this.$refs['uploadthumb2'].uploadList[0].url;
          }
          if (this.$refs['uploadthumb3'].uploadList.length > 0) {
            this.itemtype.bigicon = this.$refs['uploadthumb3'].uploadList[0].url;
          }
          if (this.$refs['uploadthumb4'].uploadList.length > 0) {
            this.itemtype.typeicon = this.$refs['uploadthumb4'].uploadList[0].url;
          }
          if (this.$refs['uploadthumb5'].uploadList.length > 0) {
            this.itemtype.typeicon1 = this.$refs['uploadthumb5'].uploadList[0].url;
          }
          if (this.itemtype.id == null || this.itemtype.id == 0) {
            this.$api.itemtype.create(this.itemtype).then(res => {
              this.tijiaoloading = false;
              if (res.code == 200) {
                this.showModalStatus = !this.showModalStatus;
                this.getTableList();
              }

            });
          } else {
            this.$api.itemtype.edit(this.itemtype).then(res => {
              this.tijiaoloading = false;
              if (res.code == 200) {
                this.showModalStatus = !this.showModalStatus;
                this.getTableList();
              }
            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.tijiaoloading = false;
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.itemtype.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.itemtype.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    changesort: function (id, sort) {
      this.$api.itemtype.sort({ id: id, sort: sort }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size };
      this.$api.itemtype.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  },
}
  </script>
  